import * as Stimulus from "@hotwired/stimulus"

export class MenuTypeController extends Stimulus.Controller {
    static targets = ["menuSelect", "itemsPerGuest", "dollarCredit", "customMenu"]
    static values = {
        defaultType: String
    }

    connect() {
        const initialType = this.hasDefaultTypeValue
            ? this.defaultTypeValue
            : this.currentSelectValue()
        if (initialType) {
            this.showForType(initialType)
            // Trigger downstream form listeners (fine print preview, validation) once
            // menu-type-dependent disabled states are applied.
            requestAnimationFrame(() => {
                this.element.dispatchEvent(new Event("input", { bubbles: true }))
            })
        }
    }

    selectType() {
        const selected = this.currentSelectValue()
        if (selected) {
            this.showForType(selected)
        }
    }

    currentSelectValue() {
        if (this.hasMenuSelectTarget) {
            return this.menuSelectTarget.value
        }
        const fallbackSelect = this.element.querySelector("select")
        return fallbackSelect ? fallbackSelect.value : null
    }

    showForType(selectedType) {
        const sections = {
            ItemsPerGuest: this.itemsPerGuestTarget,
            DollarCredit: this.dollarCreditTarget,
            CustomMenu: this.customMenuTarget
        }

        for (const [key, section] of Object.entries(sections)) {
            const isActive = key === selectedType
            section.classList.toggle("hidden", !isActive)
            section.setAttribute("aria-hidden", (!isActive).toString())
            for (const input of section.querySelectorAll("input, textarea, select")) {
                input.disabled = !isActive
            }
        }
    }
}
